import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

interface StudentFeaturePlaceholderPageProps {
  title: string;
  description: string;
}

const StudentFeaturePlaceholderPage: React.FC<StudentFeaturePlaceholderPageProps> = ({
  title,
  description,
}) => {
  return (
    <div className="p-4 sm:p-6 lg:p-8">
      <Card className="">
        <CardHeader>
          <CardTitle className="text-foreground">{title}</CardTitle>
          <CardDescription>{description}</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-gray-300 text-sm">
            This page is ready in the route structure and can now be connected to full student
            workflows.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default StudentFeaturePlaceholderPage;

